export const AppUrl = process.env.VERCEL_URL
  ? `https://${process.env.VERCEL_URL}`
  : `http://${process.env.DEV_URL}`